import * as React from 'react';
import classNames from 'classnames';
import './stepIndicator.module.scss';

export type StepSpec = {
  id: number;
  subTitle: string;
  title: string;
  visibleOnError: boolean;
  error?: boolean;
};

type ItemProps = {
  spec: StepSpec;
  current: boolean;
};

const StepItem = ({ spec, current }: ItemProps) => {
  return (
    <React.Fragment>
      <div styleName={classNames('step-item', { current: current, error: spec.error })}>
        <div styleName="subtitle">{spec.subTitle}</div>
        <div styleName="title">{spec.title}</div>
      </div>
    </React.Fragment>
  );
};

type Props = {
  currentStep: number;
  steps: StepSpec[];
  error?: boolean;
};

export const StepIndicator = ({ currentStep, steps, error = false }: Props) => {
  const filterSteps = (step) => {
    if (error) {
      return step.visibleOnError;
    } else {
      return step.error !== true;
    }
  };
  return (
    <div styleName="step-indicator">
      {steps.filter(filterSteps).map((step) => (
        <StepItem key={step.id} spec={step} current={step.id === currentStep} />
      ))}
    </div>
  );
};
